export default "__VITE_ASSET__DYBjfXFu__"